import { SortDirection } from '../../../../utils/constants';
import { createSearchPageSlice } from '../../../Generic/SearchPage/slices/searchPageSlice';

export const filterFields = {
  Source: 'Source',
  SourceID: 'SourceID',
  Target: 'Target',
  TargetID: 'TargetID'

};
const initialFilterState = {
  Source: '',
  SourceID: '',
  Target: '',
  TargetID: ''

};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'Source',
  sortDirection: SortDirection.Asc,
};

export const sliceName = 'linkTableSearch';
const linkTableSearchSlice = createSearchPageSlice({
  sliceName,
  initialFilterState,
  filterFields,
  initialPageState
});

export const linkTableSearchActions = linkTableSearchSlice.actions;
export default linkTableSearchSlice.reducer;
